import { render, staticRenderFns } from "./image.vue?vue&type=template&id=b0fe9eb0&scoped=true&"
import script from "./image.vue?vue&type=script&lang=ts&"
export * from "./image.vue?vue&type=script&lang=ts&"
import style0 from "./image.vue?vue&type=style&index=0&id=b0fe9eb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fe9eb0",
  null
  
)

export default component.exports